(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-option-info-button"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('option-info')) {
    class OptionInfo extends HTMLElement {
      connectedCallback() {
        if (this.dataset.bound === 'true') return;
        this.dataset.bound = 'true';
        this.button = this.querySelector('button');
        this.onClick = (event) => {
          event.preventDefault();
          event.stopPropagation();
          if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
          const open = this.classList.toggle('is-open');
          this.button.setAttribute('aria-expanded', open ? 'true' : 'false');
        };
        this.onDocumentClick = (event) => {
          if (this.contains(event.target)) return;
          this.classList.remove('is-open');
          this.button.setAttribute('aria-expanded', 'false');
        };
        this.onKeydown = (event) => {
          if (event.key !== 'Escape') return;
          this.classList.remove('is-open');
          this.button.setAttribute('aria-expanded', 'false');
        };
        this.button.addEventListener('click', this.onClick);
        this.addEventListener('keydown', this.onKeydown);
        document.addEventListener('click', this.onDocumentClick);
      }

      disconnectedCallback() {
        this.button?.removeEventListener('click', this.onClick);
        this.removeEventListener('keydown', this.onKeydown);
        document.removeEventListener('click', this.onDocumentClick);
      }
    }

    customElements.define('option-info', OptionInfo);
  }
  } catch(e) { console.error(e); }
})();

})();
